const BOL_STATE = Object.freeze({
  NoDoc: 'no-doc',
  WaitingSignature: 'waiting-signature',
  Signed: 'signed'
});

export default BOL_STATE;
